import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { Animations } from '../../../../animations';

@Component({
  selector: 'lib-fw-animation-wrapper',
  templateUrl: './animation-wrapper.component.html',
  animations: [Animations.slideInOut],
})
export class FormlyAnimationWrapperComponent extends FieldWrapper {
  @ViewChild('fieldComponent', { read: ViewContainerRef }) fieldComponent: ViewContainerRef;
}
